const avatarVersionByPlayerId = new Map<string, number>();

export function setAvatarCacheBuster(playerId: string, version: number): void {
  const id = playerId.trim();
  if (!id) return;
  if (!Number.isFinite(version)) return;
  avatarVersionByPlayerId.set(id, version);
}

export function getAvatarCacheBuster(playerId?: string | null): number | undefined {
  const id = (playerId ?? '').trim();
  if (!id) return undefined;
  return avatarVersionByPlayerId.get(id);
}
